module.exports = __webpack_public_path__ + "img/Slice5en-min.d4abde49.png";